import React, { useState, useEffect } from "react";
import {Button, InputGroup} from "react-bootstrap";
import {Plus, PatchMinus, Dash} from "react-bootstrap-icons";

interface IServiceCounter {
  setServiceIDsInBasket2: React.Dispatch<React.SetStateAction<object>>, //заявка
  sid: number,
  count: number,
}

export const ServiceCounter = ({ sid, setServiceIDsInBasket2, count }: IServiceCounter) => {
  const [val, setVal] = useState(count)

  useEffect(() => {
    setVal(count)
  }, [count])
  const onInc = () => {
    setServiceIDsInBasket2(prev => ({...prev, [sid]: val+1}))
    /*setServiceIDsInBasket( prev => {
     // return incrementServiceCountFromBasketArr(prev, sid)
    })*/
    setVal(val+1)
  }

  const onDec = () => {
    setServiceIDsInBasket2(prev => ({...prev, [sid]: val-1}))
    /*setServiceIDsInBasket( prev => {
     // return decrementServiceCountFromBasketArr(prev, sid)
    })*/
    setVal(val-1)
  }

  /*useEffect(() => {
    setServiceIDsInBasket(prev => {
      let len = prev.length
      for(let i = 0; i < len; i+=2) {
        if(prev[i] == sid) {
          prev[i] = val
          break
        }
      }
      return prev
    })
  }, [val])*/
  return (
    <div className="m-auto rounded" style={{border: "2px solid rgba(34, 84, 157, 0.35)", maxHeight: "32px"}}>
      <Button className="m-auto p-0 bg-white" style={{borderRight: "2px solid rgba(34, 84, 157, 0.35)", borderRadius: "0.25rem 0 0 0.25rem"}} variant="default" onClick={onDec}><Dash style={{}} /></Button>
      <span className="m-auto  pl-2 pr-2 pb-0 border border-0">{val}</span>
      <Button className="m-auto  p-0 bg-white" style={{borderLeft: "2px solid rgba(34, 84, 157, 0.35)", borderRadius: "0 0.25rem 0.25rem 0"}}  variant="default" onClick={onInc}><Plus style={{}} /></Button>
  </div>
  )

  /*
<div className="m-auto rounded" style={{border: "2px solid rgba(34, 84, 157, 0.35)", maxHeight: "32px"}}>
      <Button className="m-auto p-0 bg-white" style={{borderRight: "2px solid rgba(34, 84, 157, 0.35)", borderRadius: "0.25rem 0 0 0.25rem"}} variant="default" onClick={onDec}><Dash style={{fontSize: "25px", borderRadius: "50%!important"}} /></Button>
      <span className="m-auto  pl-2 pr-2 pb-0 border border-0">{val}</span>
      <Button className="m-auto  p-0 bg-white" style={{borderLeft: "2px solid rgba(34, 84, 157, 0.35)", borderRadius: "0 0.25rem 0.25rem 0"}}  variant="default" onClick={onInc}><Plus style={{fontSize: "25px", borderRadius: "50%!important"}} /></Button>
  </div>
  */
};
